module.exports = function getResource(label) {
    let resources = {
        buttonLabel: 'S’abonner aux textos de Sephora',
        inputLabel: 'Numéro de téléphone cellulaire',
        mobilePhoneEmptyError: 'Veuillez saisir un numéro de téléphone cellulaire.',
        mobilePhoneInvalidError: 'Veuillez saisir un numéro de téléphone cellulaire valide.',
        serverErrorMessage: 'Oups! Nous avons eu de la difficulté à traiter votre demande. Veuillez essayer de nouveau.'
    };

    return resources[label];
};
